"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceMissingNotificationGlossary = exports.formatDistanceToNowLocale = void 0;
const date_fns_1 = require("date-fns");
const en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
const it_1 = __importDefault(require("date-fns/locale/it"));
const formatDistanceToNowLocale = ({ inactivityTime, locale, }) => (0, date_fns_1.formatDistanceToNow)((0, date_fns_1.subSeconds)(new Date(), inactivityTime), { locale });
exports.formatDistanceToNowLocale = formatDistanceToNowLocale;
exports.deviceMissingNotificationGlossary = {
    latestVersion: 1,
    1: {
        pushHeadings: ({ applicationName }) => ({
            it: `❌  Dispositivo inattivo | ${applicationName}`,
            en: `❌  Device is inactive | ${applicationName}`,
        }),
        pushContents: ({ deviceName, inactivityTime }) => ({
            it: `Il dispositivo "${deviceName}" è inattivo da ${(0, exports.formatDistanceToNowLocale)({ inactivityTime, locale: it_1.default })}`,
            en: `The device "${deviceName}" is inactive from ${(0, exports.formatDistanceToNowLocale)({ inactivityTime, locale: en_GB_1.default })}`,
        }),
        telegramBody: ({ applicationName, deviceName, inactivityTime, }) => ({
            it: `
<b>❌  Dispositivo inattivo | ${applicationName}</b>

Il dispositivo "${deviceName}" è inattivo da ${(0, exports.formatDistanceToNowLocale)({ inactivityTime, locale: it_1.default })}`,
            en: `
<b>❌  Device is inactive | ${applicationName}</b>

The device "${deviceName}" is inactive from ${(0, exports.formatDistanceToNowLocale)({ inactivityTime, locale: en_GB_1.default })}`,
        }),
    },
};
